import * as React from "react";

const Add: React.FC = () => {
    return (
    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27">
        <path id="Icon_material-add-circle" data-name="Icon material-add-circle" d="M16.5,3A13.5,13.5,0,1,0,30,16.5,13.5,13.5,0,0,0,16.5,3Zm6.75,14.85h-5.4v5.4h-2.7v-5.4H9.75v-2.7h5.4V9.75h2.7v5.4h5.4Z" transform="translate(-3 -3)" fill="#000000"/>
    </svg>
    );
};

export default React.memo(Add);